import { homeRoute, loginRoute } from '@/app/pages/home-login.page.tsx';
import { residentialRoute } from '@/app/pages/residential.page.tsx';
import { hospitalityRoute } from '@/app/pages/hospitality.page.tsx';
import { viewInstallationRoute } from '@/app/pages/view-installation.page.tsx';
import { aboutRoute } from '@/app/pages/about.page.tsx';
import { contactRoute } from '@/app/pages/contact-page.tsx';
import { privacyRoute } from '@/app/pages/privacy-page.tsx';

export const staticPageRoutes = [
  homeRoute,
  loginRoute,
  residentialRoute,
  hospitalityRoute,
  viewInstallationRoute,
  aboutRoute,
  contactRoute,
  privacyRoute,
];
